import script from "./clients-list.vue?vue&type=script&setup=true&lang=js"
export * from "./clients-list.vue?vue&type=script&setup=true&lang=js"

import "./clients-list.vue?vue&type=style&index=0&id=2d2a0e89&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2a0e89"]])

export default __exports__